import ItemEntry from "../../Templates/ItemEntry"

export default function SierraNevada() {
    return (
        <div className="section">
            <ItemEntry
                title="Senior Software Developer"
                company="SNC Mission Systems UK"
                dates="Jan 2026 - Present"
            >
                <p>
                    Due to confidentiality obligations, I am unable to share details of my current projects.
                </p>
            </ItemEntry>
        </div>
    );
}
